
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import HrStore from '../../../stores/HrStore'
import PrintButtons from '../../../component/element/PrintButtons'
import CkSlipPeriod from '../../../component/element/CkSlipPeriod'
import IframeModal from '../../../component/element/IframeModal'

// const localStorageKey = 'kkc.ReportSummarySlip'
class ReportSummarySlip extends Component {

  constructor(...args) {
    super(...args)

    this.state = {data:[],periodState:{},hrConfig:{},slipPeriod:[],loading:false}
    this.slipConfig = {}
    this.pdfTemplate = {}
    this.refTableId = 'ReportSummarySlip-'+Math.ceil(Math.random()*100);
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      //this.loadData()
    }
  }


  onInitPeriod(periodState){
    this.setState({periodState:periodState})
    let {year,month} = periodState
    //this.loadNetworkData(year,month,rangeValue)

    let that = this
    HrStore.loadSlipConfigPeriod(year,month,function(result){
      that.slipConfig = result.data    
      that.pdfTemplate = result.pdf_template
      //console.log('slipConfig',that.slipConfig,that.hrConfig)
      that.setState({hrConfig:result.hr_config,slipPeriod:result.slip_period})
      //resolve({that:that,newOption:newOption})
    },function(error){
      
    })
  }

  loadData(year,month,rangeValue){
    this.setState({loading:true}) 
    let that = this
    HrStore.loadAllSlipSummary(year,month,rangeValue,function(result){
      //Coding Here 
      that.setState({loading:false,data:result.data}) //tableList:result.data,
    },function(error){
                
    })
  }

  onSlipPeriodChange(periodState){
    this.setState({periodState:periodState})

    let {year,month,rangeValue} = periodState
    this.loadData(year,month,rangeValue)
  }

  onPrintTable(){
    let {periodState} = this.state
    let {year,month,rangeValue} = periodState
    
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportSummarySlip&year='+year+'&month='+month+'&between='+rangeValue.value+'&start='+rangeValue.startDate+'&end='+rangeValue.endDate
    } else{
      url = './pdf/v2/?startPage=PrintReportSummarySlip&year='+year+'&month='+month+'&between='+rangeValue.value+'&start='+rangeValue.startDate+'&end='+rangeValue.endDate
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel() {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานค่าแรงประจำ '+this.getRangeText()+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
  }

  getRangeText(){
    let {periodState} = this.state
    let {rangeValue,year} = periodState

    let betweenTitle = (rangeValue!==undefined)?(rangeValue.label + ' ' + year):''
    return betweenTitle
  }

  renderPrintButton(){
    return (
      <PrintButtons        
        onPrintTable={this.onPrintTable.bind(this)}
        onExportExcel={this.onExportExcel.bind(this)}        
        marginLeft='0'
        width='auto'  
    />
    )
  }
  
  renderToolbar() {
    let {hrConfig,slipPeriod} = this.state
    return (
      <div>
        <CkSlipPeriod 
          hrConfig={hrConfig} 
          slipPeriod={slipPeriod} 
          show={this.props.show}
          onInitPeriod={this.onInitPeriod.bind(this)}
          onChange={this.onSlipPeriodChange.bind(this)}
        />
        {this.renderPrintButton()}        
      </div>
    )
  }

  renderRowData(){
    let {data} = this.state
    if(data.length===0){
      return (<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
    } else {
      return data.map((item,index)=>(
        <tr key={index}>
          <td className='text-center'>{index+1}</td>
          <td>{item.description}</td>
          <td className='text-right'>{this.getValue(item.salary)}</td>
          <td className='text-right'>{this.getValue(item.wage_amount)}</td>
          <td className='text-right'>{this.getValue(item.withdraw_amount)}</td>
          <td className='text-right'>{this.getValue(item.ot_hour)}</td>
          <td className='text-right'>{this.getValue(item.ot_sunday)}</td>
          <td className='text-right'>{this.getValue(item.ot_amount)}</td>
          <td className='text-right'>{this.getValue(item.deduction_withdraw)}</td>
          <td className='text-right'>{this.getValue(item.net_balance)}</td>
          <td className='text-right'>{this.getValue(item.net_unpaid)}</td>
        </tr>
      ))
    }  
  }

  getValue(value) {
    if (isNaN(value)||value===undefined||value===''||value===null) {
      return value
    } else {
      return value.toLocaleString(undefined, {maximumFractionDigits: 2})
    }  
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      if (isNaN(item[key])||item[key]===undefined||item[key]===''||item[key]===null) {
        item[key] = 0 
      }
      sum = parseFloat(item[key]) + parseFloat(sum)
    })
    return sum.toLocaleString(undefined, {maximumFractionDigits: 2})
  }

  renderTableFooter(){
    return (
      <tr>
        <th className='text-center' colSpan={2}>{'รวมค่าแรงพนักงาน ประจำวันที่ '+this.getRangeText()}</th>
        <th className='text-right'>{this.getSummary('salary')}</th>
        <th className='text-right'>{this.getSummary('wage_amount')}</th>
        <th className='text-right'>{this.getSummary('withdraw_amount')}</th>
        <th className='text-right'>{this.getSummary('ot_hour')}</th>
        <th className='text-right'>{this.getSummary('ot_sunday')}</th>
        <th className='text-right'>{this.getSummary('ot_amount')}</th>
        <th className='text-right'>{this.getSummary('deduction_withdraw')}</th>
        <th className='text-right'>{this.getSummary('net_balance')}</th>
        <th className='text-right'>{this.getSummary('net_unpaid')}</th>
      </tr>
    )
  }

  renderTable() {
    // let {sort} = this.state
    return(
        <div className='table-responsive'>
          <table id={this.refTableId} className='table table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th style={{display:'none'}} colSpan={11}>{'รายงานค่าแรงประจำ '+this.getRangeText()}</th>
              </tr>
              <tr>
                <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' style={{width:'350px'}}>รายการ</th>
                <th className='text-center'>วันละ/เดือน</th>
                <th className='text-center'>ค่าแรง</th>
                <th className='text-center'>เบิก</th>
                <th className='text-center'>ชั่วโมง OT</th>
                <th className='text-center'>OT อาทิตย์</th>
                <th className='text-center'>จำนวนเงิน OT</th>
                <th className='text-center'>หักเบิก</th>
                <th className='text-center'>คงเหลือ</th>
                <th className='text-center'>คงเหลือค้างจ่าย</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <thead>
              {this.renderTableFooter()}
            </thead>
          </table>
        </div>  
    )
  }

  render() {
    let title = 'รายงานค่าแรงประจำ '+this.getRangeText()
    let {report} = this.props
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
        {
          report=='ReportCategoryPage'
          ?this.props.renderMenu()
          :<Box.Title>{title}</Box.Title>
        }  
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'}/>
        </Box.Body>
      </Box>
    )
  }
}

ReportSummarySlip.defaultProps = {
  show: false,
  report: ''
}

export default ReportSummarySlip;



// WEBPACK FOOTER //
// ./src/view/hr/report/ReportSummarySlip.js